import Lottie from "lottie-react";
import successpack from "../Json/successpack.json";

const Successpack = () => {
  return (
    <div>
      <div
        style={{
          width: "150px",
          height: "150px",
          margin: "0px auto",
        }}
      >
        <Lottie animationData={successpack} loop={true} />
      </div>
    </div>
  );
};
export default Successpack;
